import React from 'react';

import { useState, useContext, useEffect } from 'react';
import { StyleSheet, Text, View, KeyboardAvoidingView, TextInput, ScrollView, TouchableOpacity, Alert, ActivityIndicator, Platform } from 'react-native';

import { StatusBar } from 'expo-status-bar';
import * as Device from 'expo-device';
import * as Application from 'expo-application';

import axios from 'axios';
import uuid from 'react-native-uuid';
import CheckBox from '@react-native-community/checkbox';

import AsyncStorage from '@react-native-async-storage/async-storage';
import { CredentialsContext } from '../components/CredentialsContext';
import StyledText from '../components/StyledText';
import BoldStyledText from '../components/BoldStyledText';
import Card from '../components/Card';

import { EnglishStrings } from '../strings/English';
import { PersianStrings } from '../strings/Persian';
import { ArabicStrings } from '../strings/Arabic';


import envVars from '../env';

const TermsAndPoliciesScreen = props => {

  const [phoneNumber, setPhoneNumber] = useState([]);
  const [phoneNumberInputIsFocused , setPhoneNumberInputIsFocused] = useState(false);
  const [language, setLanguage] = useState('Persian')

  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const {storedCredentials, setStoredCredentials} = useContext(CredentialsContext);
  
  const strings = () => {
    if(language == 'English') {
        return EnglishStrings
    } else if(language == 'Arabic') {
        return ArabicStrings
    } else return PersianStrings
  }

  useEffect(()=> {
    // changeLanguage('Arabic')

    props.navigation.setOptions({
      headerStyle:{
        backgroundColor: 'transparent'
      },
      headerTransparent: true,
      headerTitle: '',
      headerLeftContainerStyle:{
        paddingLeft: 20
      },
      headerTintColor: 'white'
    });

  }, [])

  const changeLanguage = targetLanguage => {
    if(language != targetLanguage) {
        const updatedStoredCredentials = {...storedCredentials, ...{language: targetLanguage}}

        AsyncStorage.setItem('flowerCribCredentials', JSON.stringify(updatedStoredCredentials))
        .then(()=> {
            setStoredCredentials(updatedStoredCredentials)
        })
        .catch(err =>{
            console.log(err);
        })        
        
        setLanguage(targetLanguage)
    }
  }
  
  return (
    <KeyboardAvoidingView style={{flex: 1}}>
      <ScrollView contentContainerStyle={{flexGrow: 1}}>
      <View style={Styles.wrapper}>

      <StatusBar />
        <View style={Styles.contentWrapper}>
            <View style={{...Styles.headerCard, ...language == 'English' && {flexDirection: 'row'}}}>
                <View style={{justifyContent: 'center'}} > 
                    <BoldStyledText style={Styles.cardHeaderText}> {strings().termsAndPolices} </BoldStyledText>
                    <View style={Styles.descriptionOrSignin}>
                    <StyledText style={Styles.cardHeaderTextDescription}> {strings().readTermsAndPolicies} </StyledText>
                    </View>
                </View>

                <Card style={{backgroundColor: 'gray', padding: 5 }} activeOpacity={1}>
                    <TouchableOpacity style={{margin: 5}} onPress={()=> changeLanguage('Persian')}>
                    <BoldStyledText style={{color: language == 'Persian' ? '#1C0947' : 'white', fontSize: 10}}> FA </BoldStyledText>
                    </TouchableOpacity>
                    <TouchableOpacity style={{margin: 5}} onPress={()=> changeLanguage('English')}>
                    <BoldStyledText style={{color: language == 'English' ? '#1C0947' : 'white', fontSize: 10}}> EN </BoldStyledText>
                    </TouchableOpacity>
                    <TouchableOpacity style={{margin: 5}}  onPress={()=> changeLanguage('Arabic')}>
                    <BoldStyledText style={{color: language == 'Arabic' ? '#1C0947' : 'white', fontSize: 10}}> AR </BoldStyledText>
                    </TouchableOpacity>
                </Card>
            </View>

            <ScrollView style={{height: 'auto', backgroundColor: 'white', margin: 10, borderRadius: 10, padding: 10}}>
                <Text style={{fontWeight: 'bold'}}>به نام خدا</Text>
                <Text>سیاست حفظ حریم خصوصی برنامه خانه هوشمند Zitco
                </Text>
                <Text>تاریخ اجرایی: 11/6/1402
                </Text>
                <Text style={{fontWeight: 'bold'}}>1. معرفی</Text>
                <Text>
                    به برنامه خانه هوشمند Zit Kit خوش آمدید. ("Zit Kit") که توسط Zitco توسعه و ارائه شده است. در Zitco، ما متعهد به حفظ حریم خصوصی شما و محافظت از اطلاعات شخصی شما هستیم. این خط‌مشی رازداری نحوه جمع‌آوری، استفاده، افشای و محافظت از اطلاعات شما را هنگام استفاده از برنامه مشخص می‌کند. با استفاده از برنامه، با اقداماتی که در این خط مشی رازداری توضیح داده شده است، موافقت می کنید.
                </Text>
                
                <Text style={{fontWeight: 'bold'}}>2. اطلاعاتی که ما جمع آوری می کنیم</Text>
                <Text> هنگام استفاده از برنامه ما ممکن است انواع اطلاعات زیر را جمع آوری کنیم: </Text>
                <View style={{marginRight: 20}}>
                    <Text style={{fontWeight: 'bold'}}>2.1 اطلاعات شخصی:</Text>
                    <Text>شماره تلفن: ما شماره تلفن شما را جمع‌آوری می‌کنیم تا کدهای تأیید را برای ثبت نام و ورود به سیستم برای شما ارسال کنیم و همچنین برای ارائه اعلان‌های مهم مانند تخفیف‌ها و به‌روزرسانی‌ها.</Text>
                    <Text style={{fontWeight: 'bold'}}>2.2 اطلاعات استفاده:</Text>
                    <Text> اطلاعات دستگاه: برای بهبود عملکرد برنامه، ممکن است اطلاعاتی درباره دستگاه تلفن همراه شما، از جمله شناسه دستگاه منحصر به فرد، سیستم عامل، و نسخه برنامه جمع آوری کنیم. </Text>
                </View>
               
                <Text style={{fontWeight: 'bold'}}>3. چگونه از اطلاعات شما استفاده می کنیم</Text>
                <Text> ما از اطلاعات جمع آوری شده برای اهداف زیر استفاده می کنیم: </Text>
                <Text>•	به شما امکان دسترسی و استفاده از ویژگی های برنامه را می دهد.</Text>
                <Text>•	برای تایید هویت خود در طی مراحل ثبت نام و ورود به سیستم.</Text>
                <Text>•	برای برقراری ارتباط اطلاعات مهم، به روز رسانی ها و تخفیف های مربوط به محصولات و خدمات زیتکو.</Text>
                <Text>•	برای بهبود عملکرد و تجربه کاربری برنامه.</Text>
                
                <Text style={{fontWeight: 'bold'}}>4. اشتراک گذاری و افشای داده ها</Text>
                <Text>در شرایط زیر ممکن است اطلاعات شما را با اشخاص ثالث به اشتراک بگذاریم:</Text>
                <Text>•	با رضایت شما: در صورت ارائه رضایت صریح برای اهداف خاص، ممکن است اطلاعات شما را با اشخاص ثالث به اشتراک بگذاریم.</Text>
                <Text> •	به دلایل قانونی: در صورت نیاز به قانون یا در پاسخ به درخواست‌های قانونی، مانند احکام دادگاه یا احضاریه، ممکن است اطلاعات شما را فاش کنیم. </Text>

                <Text style={{fontWeight: 'bold'}}>5. امنیت داده ها</Text>
                <Text>ما اقدامات معقولی را برای محافظت از اطلاعات شخصی شما در برابر دسترسی، افشا، تغییر یا تخریب غیرمجاز انجام می دهیم. با این حال، هیچ سیستم انتقال داده یا ذخیره سازی را نمی توان تضمین کرد که 100٪ ایمن است.</Text>

                <Text style={{fontWeight: 'bold'}}>6. انتخاب های شما</Text>
                <Text> •	از طریق تنظیمات برنامه به اطلاعات خود دسترسی پیدا کرده و به‌روزرسانی کنید. </Text>
                <Text> •	حساب و داده های مرتبط خود را حذف کنید. </Text>
                <Text> •	از دریافت ارتباطات بازاریابی از ما انصراف دهید. </Text>

                <Text style={{fontWeight: 'bold'}}>7. تغییرات در این سیاست حفظ حریم خصوصی</Text>
                <Text> ما ممکن است این خط مشی رازداری را برای منعکس کردن تغییرات در شیوه های داده های ما به روز کنیم. هر گونه تغییر با تاریخ اجرایی به روز شده در این صفحه پست می شود. ادامه استفاده شما از برنامه پس از ایجاد تغییرات به معنای پذیرش سیاست حفظ حریم خصوصی اصلاح شده توسط شما است.  </Text>
            
                <Text style={{fontWeight: 'bold'}}>8. تماس با ما</Text>
                <Text> اگر سؤال، نگرانی یا درخواستی در رابطه با این سیاست حفظ حریم خصوصی دارید، لطفاً با ما درتماس باشید. </Text>
                <Text> 05138426747, 05138469096, 09152452988 </Text>
            </ScrollView>
        </View>

      </View>
      </ScrollView>
    </KeyboardAvoidingView>
  );
};


let Styles = {  
  wrapper:{
    flex: 1,
    justifyContent: 'space-between',
    backgroundColor: '#F26B08',
  },
  contentWrapper:{

  },
  headerCard:{
    width:'100%',
    minHeight: 250,
    height:'20%',
    padding: 15,
    alignSelf:'center',
    backgroundColor:'white',
    shadowColor: 'black',
    shadowOffset: {width:0 , height:2},
    shadowRadius: 6,
    shadowOpacity: 0.26,
    elevation:20,
    borderBottomStartRadius: 60 ,
    padding: 20,
    height: '30%',
    backgroundColor: '#1C0947',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  cardHeaderText:{
    fontWeight:'400',
    fontSize:50,
    color: 'white',
    // alignSelf: 'flex-end'
  },
  descriptionOrSignin:{
    flexDirection:'row-reverse'
  },
  topSignInBtn:{
    backgroundColor: '#00008B',
    borderRadius: 10,
    paddingHorizontal: 5
  },
  cardHeaderTextDescription:{
    fontSize:20,
    fontWeight:'300',
    color:'white',
    // paddingVertical: 5,
    margin:5
  },
  textInputWrapper:{
    alignItems: 'flex-end',
    margin: '5%',
    marginTop: '10%',
  },
  textInput:{
    backgroundColor: 'white',
    padding: 15,
    marginTop: 10,
    marginBottom: 20,
    borderRadius: 40,
    shadowColor: 'black',
    shadowOffset: {width:0 , height:2},
    shadowRadius: 6,
    shadowOpacity: 0.26,
    elevation:20,
    fontSize: 25,
  },
  inputLabel:{
    fontSize: 20,
    fontWeight: '500',
    color: 'white'
  },
  InputArea:{
    width: '100%',  
  },
  passwordWarningText:{
    color: 'red',

  },
  footer:{
    paddingVertical:10,
    // marginBottom: 10,
  },
  submitBtn:{
    backgroundColor: '#1C0947',
    alignItems: 'center',
    marginHorizontal:'5%',
    borderRadius: 40,
    minHeight: 60,
    justifyContent: 'center'
  },
  TermsAndPolicesBTN:{
    // backgroundColor: '#1C0947',
    // alignItems: 'center',

    marginHorizontal:'8%',
    borderRadius: 40,
    minHeight: 60,
    justifyContent: 'center'
  },
  submitBtnText:{
    fontSize: 35,
    fontWeight: '300',
    color:'white',
    padding:5
  },
  alreadySinedUpTextArea:{
    alignItems:'center',
    marginTop: '5%'
  },
  alreadySinedUpText:{
    color: '#6F8FEA'
  }
}



export default TermsAndPoliciesScreen;